import "core-js/modules/es.array.push.js";
import api from "@/api";
import DialogCustomView from "@/components/DialogCustomView.vue";
import { ElMessage } from "element-plus";
export default {
  name: "HomeView",
  components: {
    DialogCustomView
  },
  data() {
    return {
      tab: 0,
      user: {},
      scopes: [],
      colors: ['primary', 'success', 'warning', 'danger'],
      newNoteVisible: false,
      noteUpdate: [],
      pageUpdate: [],
      permissions: [],
      noticeSwitch: true,
      noticeSwitchId: null
    };
  },
  mounted() {
    api.getUserInfo().then(ret => {
      this.user = ret;
    });
    api.getEnumOptionList(2).then(ret => {
      this.scopes = ret;
    });
    this.init();
  },
  methods: {
    onNoticeSwitch() {
      api.updateEnumValueEnableState(this.noticeSwitchId, this.noticeSwitch).then(() => {
        ElMessage.success('修改成功');
      });
    },
    goTab(tabIndex) {
      this.tab = tabIndex;
      if (tabIndex == 0) {
        this.$router.push('/dashboard/0');
      } else if (tabIndex == 1) {
        this.$router.push('/xhs/list');
      } else if (tabIndex == 2) {
        this.$router.push('/user/list');
      } else if (tabIndex == 3) {
        this.$router.push('/pc/site/0');
      } else if (tabIndex == 4) {
        this.$router.push('/site/spy');
      }
    },
    logout() {
      localStorage.removeItem('access_token');
      // api.logout().then(() => {
      this.$router.go(0);
      // })
    },
    queryNoteUpdate() {
      const noteUpdate = localStorage.getItem('_NOTE_UPDATE_');
      if (!noteUpdate) {
        localStorage.setItem('_NOTE_UPDATE_', new Date().getTime());
        return;
      }
      api.queryCareNoteUpdate(noteUpdate).then(ret => {
        if (ret.update) {
          this.noteUpdate = ret.notes;
          this.pageUpdate = ret.pages;
          this.newNoteVisible = true;
        }
        localStorage.setItem('_NOTE_UPDATE_', ret.nextTime);
      });
    },
    init() {
      api.getUserInfo().then(ret => {
        this.permissions = ret.permissions;
      });
      api.getCareNoteUpdateSwitch().then(ret => {
        this.noticeSwitch = ret.enable;
        this.noticeSwitchId = ret.id;
      });
      setInterval(this.queryNoteUpdate, 10000);
    }
  }
};